import t from "../helpers/t";
import React, { useEffect, useState } from "react";
import { s3Actions, useSelector } from "inbooma-api";
// @ts-ignore
import Biscuit from "../../utils/Biscuit";
// @ts-ignore
import { getApiHost } from "../../Sync";

const ImageUpload = (props: any) => {
  const _addImage = useSelector((state: any) => state.s3_data.addImage);
  const [imagePending, setImagePending] = useState(false);
  const {
    onChange,
    image,
    type,
    setImage,
    showInput,
    showPreview,
    showPreviewLabel,
    extraClasses,
    addButtonDirection,
    addButtonText,
    imageStyle,
    portImage,
    dispatch = false,
    setImagesPending = false,
    deleteImage = false,
  } = props;
  let showInputs = true,
    showPreviews = true,
    showPreviewLabels = true,
    extraTopClasses = "",
    addButtonDirections = "up",
    addButtonTexts = "+ " + t("add_${a}", { a: t("image") }),
    imageStyles = {},
    portImages = false;
  if (typeof showInput !== "undefined") {
    showInputs = showInput;
  }
  if (typeof showPreviewLabel !== "undefined") {
    showPreviewLabels = showPreviewLabel;
  }
  if (typeof showPreview !== "undefined") {
    showPreviews = showPreview;
  }
  if (typeof extraClasses !== "undefined") {
    extraTopClasses = extraClasses;
  }
  if (typeof addButtonDirection !== "undefined") {
    addButtonDirections = addButtonDirection;
  }
  if (typeof addButtonText !== "undefined") {
    addButtonTexts = addButtonText;
  }
  if (typeof imageStyle !== "undefined") {
    imageStyles = imageStyle;
  }
  if (typeof portImage !== "undefined") {
    portImages = portImage;
  }
  useEffect(() => {
    if (_addImage.success === "" || !imagePending) {
      return;
    }
    if (_addImage.success === true) {
      if (typeof setImagesPending === "function") {
        setImagesPending(true);
      }
      setImage(_addImage.data.Location);
    }
    setImagePending(false);
  }, [_addImage]);

  const uploadFile = (fi: any) => {
    dispatch(
      s3Actions.addImage({
        file: fi,
        type: type,
        client_id: Biscuit.get("user.client_id"),
        apiEntryPoint: getApiHost(),
        token: Biscuit.get("token"),
      }),
    );
    setImagePending(true);
  };

  const onUploadFile = (e: any) => {
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      uploadFile(files[i]);
    }
  };
  const reset = () => {
    const copy = typeof image === "string" ? image : "";
    setImage("");
    if (typeof setImagesPending === "function") {
      setImagesPending(true);
    }
    if (typeof onChange === "function") {
      onChange({
        target: { id: "image_input__reset", name: "_image", value: "" },
      });
    }
    if (typeof deleteImage === "function") {
      dispatch(
        s3Actions.deleteImage({
          file: copy,
          type: type,
          client_id: Biscuit.get("user.client_id"),
          apiEntryPoint: getApiHost(),
          token: Biscuit.get("token"),
        }),
      );
      deleteImage(copy);
    }
  };
  const disabled = typeof props.disabled !== "undefined" ? props.disabled : "";
  return (
    <>
      <div className="inb-form-group-column medium-6 small-12 lang">
        {addButtonDirections === "up" && (
          <>
            <label
              htmlFor="upload-file-input"
              className="inb-form__controlLabel"
              style={{ fontSize: ".85rem", fontWeight: "normal", padding: "0 1rem" }}
            >
              {disabled === "" && (
                <>
                  <a>
                    {/* Left the href = "#" out by purpose: fileInput wouldn't get called */}
                    <i className="fi fi-page-add product-icon"></i>
                    {addButtonTexts}
                  </a>
                </>
              )}
            </label>
            <input
              id="upload-file-input"
              className="form-control"
              name="upload-file-input"
              disabled={disabled}
              type="file"
              style={{ position: "fixed", top: "-100em" }}
              onChange={onUploadFile}
            />
          </>
        )}
        {showInputs && (
          <div style={{ display: "flex", width: "100%" }}>
            <span style={{ float: "left", padding: "5px 0 5px 1rem" }}>
              {t("link", null, "capital")}:
            </span>
            <input
              type="text"
              className="form-control"
              name="_image"
              onChange={onChange}
              disabled={disabled}
              style={{ float: "left", width: "90%" }}
              value={typeof image === "string" ? image : ""}
            />
            {disabled === "" && (
              <>
                {" "}
                <a
                  href="#"
                  id={"image_input__reset"}
                  className={
                    "image_input__reset " +
                    (typeof image === "string" && image !== "" ? "" : "hide")
                  }
                  onClick={reset}
                >
                  x
                </a>
              </>
            )}
          </div>
        )}
      </div>
      {showPreviews && (
        <>
          {!portImages ? (
            <>
              <div className={"inb-form-group column medium-6 small-12 lang " + extraTopClasses}>
                {showPreviewLabels && (
                  <label className="inb-form__controlLabel">{t("preview", null, "capital")}</label>
                )}
                <div id="image" className="inb-form__controllClass" style={imageStyles}>
                  {typeof image === "string" && image !== "" && <img src={image} />}
                </div>
              </div>
            </>
          ) : (
            <>
              <div>
                {typeof image === "string" && image !== "" && (
                  <img id="client-logo-image" style={imageStyles} src={image} />
                )}
              </div>
            </>
          )}
        </>
      )}
      {addButtonDirections === "down" && (
        <>
          <label
            htmlFor="upload-file-input"
            className="inb-form__controlLabel"
            style={{ fontSize: ".85rem", fontWeight: "normal", padding: "0 1rem" }}
          >
            {disabled === "" && (
              <>
                <a>
                  {/* Left the href = "#" out by purpose: fileInput wouldn't get called */}
                  <i className="fi fi-page-add product-icon"></i>
                  {addButtonTexts}
                </a>
              </>
            )}
          </label>
          <input
            id="upload-file-input"
            className="form-control"
            name="upload-file-input"
            type="file"
            disabled={disabled}
            style={{ position: "fixed", top: "-100em" }}
            onChange={onUploadFile}
          />
        </>
      )}
    </>
  );
};
export default ImageUpload;
